<as-split (dragEnd)="splitterDragEnd($event)" (dragStart)="splitterDragStart($event)" direction="horizontal"
  class="schedule-container">
  <as-split-area [maxSize]="70" [minSize]="10" [size]="scheduleWidth"></as-split-area>
  @if (showMap) {
  <as-split-area [maxSize]="70" [minSize]="10" [size]="mapWidth">
    <app-live-map #liveMap (ticketHoverChange)="ticketHoverChange($event)" [dateFrom]="initStartDate"
      [dateTo]="initEndDate"></app-live-map>
  </as-split-area>
  }
</as-split>

@if (!scheduleProjectService.ticketLoaded || !scheduleProjectService.availabilityLoaded ||
!scheduleProjectService.baseDataLoaded || !scheduleProjectService.resourcesLoaded) {
<div class="loading-screen">
  <div class="loading-content">
    <h1>Loading Schedule View</h1>
    <div class="loading-status-list">
      @if (!scheduleProjectService.baseDataLoaded) {
      <div class="loading-status-item">
        <mat-icon>check_box_outline_blank</mat-icon>
        <span>Base Data Loading</span>
      </div>
      }
      @if (scheduleProjectService.baseDataLoaded) {
      <div class="loading-status-item">
        <mat-icon>check_box</mat-icon>
        <span>Base Data Loaded</span>
      </div>
      }
      @if (!scheduleProjectService.resourcesLoaded) {
      <div class="loading-status-item">
        <mat-icon>check_box_outline_blank</mat-icon>
        <span>Resources Loading</span>
      </div>
      }
      @if (scheduleProjectService.resourcesLoaded) {
      <div class="loading-status-item">
        <mat-icon>check_box</mat-icon>
        <span>Resources Loaded</span>
      </div>
      }
      @if (!scheduleProjectService.availabilityLoaded) {
      <div class="loading-status-item">
        <mat-icon>check_box_outline_blank</mat-icon>
        <span>Availability Loading</span>
      </div>
      }
      @if (scheduleProjectService.availabilityLoaded) {
      <div class="loading-status-item">
        <mat-icon>check_box</mat-icon>
        <span>Availability Loaded</span>
      </div>
      }
      @if (!scheduleProjectService.ticketLoaded) {
      <div class="loading-status-item">
        <mat-icon>check_box_outline_blank</mat-icon>
        <span>Tickets Loading</span>
      </div>
      }
      @if (scheduleProjectService.ticketLoaded) {
      <div class="loading-status-item">
        <mat-icon>check_box</mat-icon>
        <span>Tickets Loaded</span>
      </div>
      }
    </div>
  </div>
</div>
}

<ngx-ui-loader [loaderId]="'scheduleLoad'"></ngx-ui-loader>